<template>
  <RouterView
    :products="products"
    :page-info="pageInfo"
    :products-loading="loading"
    :product-category="productCategory"
    :event="event"
    :kiosk-id="props.kiosk.id"
    :product-id="productId"
    :order-data="productData"
  />
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useProductByIdQuery, type EventBySlugQuery, type KioskUnion, type ProductCategory } from '@/gql/myomr'
import { toGlobalId } from '@/helpers/globalIdHelper'
import { useFestivalShopStore } from '@/stores/festivalShop'
import type { ExtrasOrderNode } from '@/views/FestivalShop'
import { buildEditorOrderData } from '@/views/FestivalShop/orderEditorItem'

const props = defineProps<{
  event: EventBySlugQuery['eventBySlug']
  kiosk: KioskUnion
  productCategories: ProductCategory[]
  extrasOrders: ExtrasOrderNode[]
}>()

const route = useRoute()

const categoryId = computed(() => {
  return toGlobalId('ProductCategory', route.params['categoryId'] as string)
})
const productId = computed(() => {
  return route.params['productId'] as string
})
const productGlobalId = computed(() => {
  return toGlobalId('Product', productId.value)
})

const orderId = computed(() => {
  return toGlobalId('ExtrasOrder', route.params['orderId'] as string)
})

const { result, loading } = useProductByIdQuery(() => ({
  rootEvent: { slug: props.event.rootEvent.slug },
  kioskId: props.kiosk.id,
  id: productGlobalId.value,
}))
const festivalShopStore = useFestivalShopStore()
const products = computed(() => {
  return result.value?.productById ? [result.value.productById] : []
})
const pageInfo = computed(() => undefined)
const productCategory = computed(() => {
  return props.productCategories
    .filter((pc) => {
      return pc.id == categoryId.value
    })
    .at(0)
})

const productData = computed(() => {
  const order = props.extrasOrders.filter((eo) => eo.id == orderId.value).at(0)
  return buildEditorOrderData(order?.extras.filter((e) => e.product.id == toGlobalId('Product', productId.value)).at(0))
})

watch(
  productCategory,
  (category) => {
    festivalShopStore.setCurrentProductCategory(category ?? null)
  },
  { immediate: true },
)

onBeforeUnmount(() => {
  festivalShopStore.setCurrentProductCategory(null)
})
</script>
